'use client';

import type { ReactNode } from 'react';
import {
  PipelineStep,
  type PipelineAfter,
  type PipelineBranch,
  type PipelineRole,
} from '../Pipeline';
import type { Highlight } from './paint';
import type { Stage } from './stages';
import styles from './ScrollyPulse.module.css';

/* Editorial markers. They render themselves and carry the scroll model as
   data attributes - ScrollyPulse reads it back from the DOM, which survives
   the server -> client boundary (element-type sniffing does not). */

export type SectionProps = {
  stage: Stage;
  highlight?: Highlight;
  children: ReactNode;
};

export const Section = ({ stage, highlight, children }: SectionProps) => (
  <div
    data-scrolly="section"
    data-stage={stage}
    data-highlight={highlight ? `${highlight.from}|${highlight.to}` : undefined}
  >
    <div className={styles.parallax}>{children}</div>
  </div>
);

export type GateProps = {
  label: string;
  role?: PipelineRole;
  branch?: PipelineBranch;
  after?: PipelineAfter;
  end?: boolean;
};

export const Gate = ({
  label,
  role = 'transform',
  branch,
  after,
  end,
}: GateProps) => (
  <PipelineStep
    label={label}
    role={role}
    branch={branch}
    after={after}
    end={end}
    className={styles.gate}
    data-scrolly="gate"
    aria-hidden={true}
  />
);
